export default __webpack_public_path__ + "media/images/svg/ico-close-0d63fab1ba6fd1e91d42e4eba296c2c2.svg";